<template>
  <div id="app">
      <router-view/>
   
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html,body{
    height: 100%;
    overflow: hidden;
}
ul,li{
    list-style: none;
}
a{
    /* color: #fff; */
    text-decoration: none;
}
#app{
  height: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0.8;
}
.logo{
    position: absolute;
    left: 80px;
    top: 70px;
    z-index: 999;
}

</style>



// WEBPACK FOOTER //
// src/App.vue